<template>
  <b-modal
    id="modal"
    ref="modal"
    size="md"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="handleOk"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <b-container fluid class="p-a-0">
        <h3>Tem certeza que deseja desassociar?</h3>
        <div class="mt-2" style="display: flex; justify-content: space-evenly">
          <b-btn @click="showModal = false" variant="secondary">
            Cancelar
          </b-btn>
          <b-btn @click="onStore()" variant="secondary" :disabled="isDisabled">
            Confirmar
          </b-btn>
        </div>
      </b-container>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";
import moment from "moment";

export default {
  components: {
    AvisoErros,
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: "",
  },
  data() {
    return {
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      id: "",
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalGrupo: false,
      isFullscreen: false,
      errors_array: [],
      form: new Form({
        status: "",
        doctransp_id: "",
      }),
      fields: [],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        // this.onUpdate(this.form.peduncatr_id);
      }
    },
    onCreate(data) {
      // console.log(data)
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "";
      this.modal_botao = "Enviar";
      this.modal_acao = "i";
      this.form.reset();
      this.form.doctransp_id = data;
      this.$refs.modal.show();
    },
    onStore(id) {
      this.loading = true;
      this.isDisabled = true;
      id = this.form.doctransp_id;
      this.form
        .patch("/api/auditoria/desassociar/" + id)
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
            new ReturnApi(errors, this, true, null, null, false);
            console.log(1);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              console.log(errors);
              console.log(property);
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
